import { MutationTree } from "vuex";
import { IAppState } from "./interface";

export default <MutationTree<IAppState>> {

	increaseAppKey(state) {
		state.appKey++;
	},

	increaseContentKey(state) {
		state.contentKey++;
	}

}